import { TextField } from "final-form-material-ui"
import { usePrequalif } from "hooks/usePrequalif"
import React from "react"
import { FieldRenderProps } from "react-final-form"

export const PrequalTextfieldWrapper: React.FunctionComponent<FieldRenderProps<any>> = (props) => {
  const { saveJob } = usePrequalif()
  return <TextField {...props} onBlur={() => saveJob()} />
}
